module.exports = __webpack_public_path__ + "img/red_circle.7758c8c1.gif";